module.exports = __webpack_public_path__ + "img/ari-splash-01.f7ce6dd5.jpg";